import React from "react";

import { Flex } from "@olist/design-system";
import { PageLoading } from "@olist/templates";

export function Loading() {
  return (
    <Flex marginTop="6vh">
      <PageLoading />
    </Flex>
  );
}
